/**
 * @fileoverview Zod schema for the two-factor verification form.
 * @description The code field's own length check never actually surfaces as a visible validation
 * error — TwoFactorForm already gates the submit button on "all digits entered" the same way it
 * did before this schema existed — but the form still runs through it for two reasons: it's the
 * single source of truth for the field's shape (TwoFactorFormValues), and it's a defense-in-depth
 * check should the submit button's gating logic ever change.
 * @copyright Copyright (c) 2026 Brownbox Consulting. All rights reserved.
 * @author Rahul Chawda
 */

import { z } from 'zod'

import { OTP_CODE_LENGTH } from '@/features/auth/constants/two-factor.constants'

export const twoFactorFormSchema = z.object({
  code: z.string().length(OTP_CODE_LENGTH),
})

export type TwoFactorFormValues = z.infer<typeof twoFactorFormSchema>
